module.exports = __webpack_public_path__ + "media/images/signatures/content-bg-4-f5a49400241bb65cf195b13444efbea3.png";